import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Container, Button, Row, Col, Form, Spinner } from "react-bootstrap";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";

import { API_URL } from "../utils/config";
const InfographicsFragment = () => {
  const [courses, setCourses] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    company: "",
    thumbnail: null,
  });
  const [isEdit, setIsEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchCompanies();
  }, []);

  useEffect(() => {
    fetchCourses(currentPage);
  }, [currentPage, selectedCompany]); // Add formData.company to the dependencies

  const fetchCourses = async (page) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    let apiUrl = `${API_URL}/admin/info?page=${page}&limit=5`;
    if (selectedCompany) {
      apiUrl += `&companyId=${selectedCompany}`; // Append company ID if selected
    }

    fetch(apiUrl, requestOptions)
      .then((response) => {
        if (response.status === 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => {
        setCourses(result.infographics);
        setTotalPages(result.totalPages);
        setCurrentPage(result.currentPage);
      })
      .catch((error) => console.error(error));
  };

  const fetchCompanies = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(`${API_URL}/admin/companies`, requestOptions)
      .then((response) => {
        if (response.status == 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => setCompanies(result))
      .catch((error) => console.error(error));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const formdata = new FormData();
      formdata.append("image", formData.thumbnail, formData.thumbnail.name);
      formdata.append("company", formData.company);
      formdata.append("userID", formData.userID);
      formdata.append("title", "");
      formdata.append("description", formData.description);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      const logoResponse = await fetch(
        `${API_URL}/admin/info`,
        requestOptions
      );

      if (!logoResponse.ok) {
        alert("Failed to create infographics, please try again!!");
        throw new Error("Failed to upload logo");
      }

      setFormData({
        title: "",
        description: "",
        company: "",
        userID: localStorage.getItem("userId"),
        thumbnail: null,
      });
      alert("Infographics created successfully!!");
      await fetchCourses();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      alert("Failed to create infographics, please try again!!");
      setIsLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
      const formdata = new URLSearchParams();
      if (formData.thumbnail) {
        formdata.append("image", formData.thumbnail, formData.thumbnail.name);
      }
      if (formData.company) {
        formdata.append("isPublic", false);
        formdata.append("company", formData.company);
      } else {
        formdata.append("isPublic", true);
      }
      formdata.append("title", formData.title);
      formdata.append("description", formData.description);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      console.log(formData.courseIdToUpdate);
      const response = await fetch(
        `${API_URL}/admin/info/${formData.courseIdToUpdate}`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error("Failed to update course");
      }

      setFormData({
        title: "",
        description: "",
        company: "",
        userID: localStorage.getItem("userId"),
        thumbnail: null,
      });
      alert("Infographics updated successfully!");
      await fetchCourses();
      setIsEdit(false);
      setIsLoading(false);
    } catch (error) {
      console.log();
      alert("Failed to update course, please try again!");
      setIsLoading(false);
    }
  };

  const handleEdit = (course) => {
    setFormData({
      ...formData,
      title: course.title,
      description: course.description,
      company: course.isPublic ? "" : course.company._id,
      courseIdToUpdate: course._id,
    });
    setIsEdit(true);
  };

  const handleDelete = async (courseId) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this infographic?"
    );
    if (!isConfirmed) return;
    try {
      const response = await fetch(
        `${API_URL}/info/${courseId}`,
        {
          method: "DELETE",
          headers: { Authorization: localStorage.getItem("token") },
        }
      );
      if (response.ok) {
        alert("Infographic deleted successfully");
        await fetchCourses();
      } else {
        alert("Failed to delete infographic");
      }
    } catch (error) {
      console.error("Error deleting infographic:", error);
      alert("Failed to delete infographic");
    }
  };

  return (
    <Grid
      item
      xs={10}
      style={{
        padding: "20px",
        height: "100%",
        fontFamily: "Noto Sans",
        fontWeight: "500",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container fluid style={{ height: "100%" }}>
        <Row>
          <Col
            xs={8}
            style={{
              height: "90vh",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "start",
            }}
          >
            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "row",
                marginBottom: "10px",
              }}
            >
              <Form.Group controlId="formCompanyFilter" style={{ flex: 1 }}>
                <Form.Control
                  className="w-100"
                  style={{ width: "100%", borderRadius: "10px" }}
                  as="select"
                  value={selectedCompany}
                  onChange={(e) => {
                    setSelectedCompany(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">All Infographics</option>
                  {companies.map((company) => (
                    <option key={company._id} value={company._id}>
                      {company.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              <div style={{ width: "20px" }} />
              <div style={{ flex: 1 }} />
            </div>
            <div style={{ height: "10px" }} />
            {courses.length > 0 ? (
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Image</th>
                    <th>Description</th>
                    <th>School</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {courses.map((course) => {
                    return (
                      <tr key={course._id}>
                        <td>
                          <img
                            src={`${API_URL}/${course.imageUrl}`}
                            height="50"
                            className="d-inline-block align-center"
                            alt="Thumbnail"
                          />
                        </td>
                        <td>{course.description}</td>
                        <td>
                          {course.isPublic ? "Global" : course.company.name}
                        </td>
                        <td>
                          <EditNoteIcon
                            onClick={() => handleEdit(course)}
                            style={{ color: "green", cursor: "pointer" }}
                          />
                          <DeleteSweepIcon
                            onClick={() => handleDelete(course._id)}
                            style={{ color: "red", cursor: "pointer" }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <div style={{ flex: 1, textAlign: "center" }}>
                No infographics found, please try again!
              </div>
            )}
            <div style={{ flex: 1 }} />
            <nav aria-label="Courses pagination">
              <ul className="pagination">
                {[...Array(totalPages).keys()].map((page) => (
                  <li
                    key={page}
                    className={`page-item ${
                      currentPage === page + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(page + 1)}
                    >
                      {page + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          </Col>
          <Col xs={4}>
            <h4 style={{ marginTop: "15px" }}>
              {isEdit ? "Modify" : "Create"} Infographic
            </h4>
            <Form
              style={{ fontFamily: "Noto Sans" }}
              className="w-100"
              onSubmit={isEdit ? handleUpdate : handleSubmit}
            >
              <Form.Group controlId="formCompany">
                <Form.Label style={{ fontWeight: "500", borderRadius: "20px" }}>
                  School
                </Form.Label>
                <Form.Control
                  className="w-100"
                  style={{ width: "100%", borderRadius: "20px" }}
                  as="select"
                  value={formData.company}
                  onChange={(e) =>
                    setFormData({ ...formData, company: e.target.value })
                  }
                >
                  <option value="">Select a school</option>
                  {companies.map((company) => (
                    <option key={company._id} value={company._id}>
                      {company.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="formInfographicDescription">
                <Form.Label style={{ fontWeight: "500", borderRadius: "20px" }}>
                  Description
                </Form.Label>
                <Form.Control
                  className="w-100"
                  style={{ width: "100%", borderRadius: "20px" }}
                  as="textarea"
                  rows={3}
                  placeholder="Enter infographic description"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                />
                {/* <p style={{ color: 'grey', fontSize: '12px' }}>{formData.description.length}/70</p> */}
              </Form.Group>
              <Form.Group controlId="formInfographicThumbnail">
                <Form.Label style={{ fontWeight: "500", borderRadius: "20px" }}>
                  Upload Infographic
                </Form.Label>
                <Form.Control
                  type="file"
                  className="w-100"
                  onChange={(e) =>
                    setFormData({ ...formData, thumbnail: e.target.files[0] })
                  }
                  style={{ width: "100%", borderRadius: "20px" }}
                />
              </Form.Group>
              <Button
                style={{
                  fontWeight: "600",
                  borderRadius: "20px",
                  marginTop: "15px",
                }}
                className="w-100"
                variant="primary"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : null}
                {isEdit ? "Modify" : "Create"} Infographic
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </Grid>
  );
};

export default InfographicsFragment;
